<template>
  <div class="addCard">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>Exhibitor Badge Application</el-breadcrumb-item>
      <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :span="18" :model="tktObj" :rules="rules" label-position="right" ref="ruleForm" label-width="140px" class="demo-ruleForm">
      <template v-for="(item,ind) in tktList.list">
        <template v-if="item.fieldKey != 'tktCountry' && item.fieldKey != 'tktProvince' && item.fieldKey != 'tktBthCode' && item.fieldKey != 'tktGender' && item.fieldKey != 'tktType' && item.fieldKey != 'tktIdType'  && item.fieldKey != 'tktCity' && item.fieldKey != 'photo' && item.fieldKey != 'atrID' && item.fieldKey != 'tktPrintLanguage'">
          <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
            <template v-if="item.fieldKey == 'tktTel' || item.fieldKey == 'tktFax' ">
                <el-input v-model="tktObj[item.fieldKey]" :placeholder="item.fieldHolder"></el-input>
            </template>
            <template v-else>
              <!-- :disabled="item.fieldKey === 'tktComName'"  -->
              <el-input  v-model="tktObj[item.fieldKey]" :placeholder='item.fieldHolder'></el-input>
            </template>
          </el-form-item>
        </template>
        <!-- 性别 -->
        <template v-if="item.fieldKey == 'tktGender'">
          <el-form-item  :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
            <el-radio-group v-model="tktObj[item.fieldKey]">
              <el-radio label="男">男</el-radio>
              <el-radio label="女">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </template>
        <!-- 胸卡语言 -->
        <template v-if="item.fieldKey == 'tktPrintLanguage'">
          <el-form-item  :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
            <el-select v-model="tktObj[item.fieldKey]" :placeholder="item.fieldHolder" :rulus="rulesFn(item)">
              <el-option label="CN" value="cn"></el-option>
              <el-option label="EN" value="en"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <!-- 展位号 -->
        <template v-if="item.fieldKey == 'tktBthCode'">
          <el-form-item :label="item.fieldName" :key="ind" :prop="item.fieldKey" :rules="rulesFn(item)">
            <el-input   v-model.trim="tktObj[item.fieldKey]" disabled ></el-input>
          </el-form-item>
        </template>
        <!-- 身份证件类型 -->
        <template v-if="item.fieldKey == 'tktIdType'">
          <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
            <el-select v-model="tktObj[item.fieldKey]" :placeholder="item.fieldHolder"  @change="idTypeChange">
              <el-option v-for="(item, index) in cerType" :key="index" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="item.fieldKey == 'tktCountry'">
          <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
            <el-select v-model="tktObj[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeCountry'>
              <el-option v-for="(item, index) in countryList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="item.fieldKey == 'tktProvince'">
          <el-form-item :label="item.fieldName" :prop="item.fieldKey" :key="ind"  :rules="rulesFn(item)">
            <el-select v-model="tktObj[item.fieldKey]" :placeholder="item.fieldHolder" @change='changeProvince' :disabled="provinceList.length<=0">
              <el-option v-for="(item, index) in provinceList" :key="index" :label="item.zptProvince" :value="item.zptProvince"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="item.fieldKey == 'tktCity'">
          <el-form-item :label="item.fieldName" :prop="item.fieldKey"  :key="ind"  :rules="rulesFn(item)">
            <el-select v-model="tktObj[item.fieldKey]" :placeholder="item.fieldHolder" :disabled="citysList.length<=0">
              <el-option v-for="(item, index) in citysList" :key="index" :label="item.zptCity" :value="item.zptCity"></el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="item.fieldKey == 'photo' && isShowPhoto">
            <el-form-item :label="item.fieldName" :prop="item.fieldKey" :rules="rulesFn(item)" :key="ind">
                <el-input v-model="tktObj[item.fieldKey]" style="display:none"/>
              <Upload :isFaceRead="true" :mediaUrl.sync="tktObj[item.fieldKey]"  :typeString = '"T"'/>
            </el-form-item>
        </template>
      </template>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :style="buttonStyle" @click="submitForm('ruleForm')">Save</el-button>
      <el-button @click="cancelAdd">Cancel</el-button>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import reg from '@/utils/regExp'
import Upload from '@/components/UploadCropper'
import tools from '../../utils/tools.js';
import { validRank, validateChineseZipCode, validateTelele, validateMobile, validateEmail, validateIDcard, validateAddress, realNameVerification } from '@/utils/validator'
export default {
  name: 'addCard',
  components: {
    Upload
  },
  data() {
    var validateTktIDCard = (rule, value, callback) => {
      if (!reg.regCId(value)) {
        callback(new Error(rule.message));
      } else {
        callback();
      }
    };
    return {
      tktList:{
        list:[]
      },
      tktObj:{
        tktID: '',
        tktBthCode: '',
      },
      countryList: [],
      provinceList: [],
      citysList: [],
      cerType: ['ID card', 'Passport', 'Mainland travel permit for Hong Kong, Macao and Taiwan residents'],
      rules: { },
      title: '添加',
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      isShowPhoto:true
    }
  },
  mounted(){
    this.getCountrys()
    this.getallprovinces()
    this.getsaasfield()
    this.type = this.$route.query.type
    this.checkisrealname()
  },
  methods: {
    checkisrealname() {
      api.checkisrealname().then(res => {
        if (res.data.code === 200) {
          sessionStorage.setItem('isRealName', res.data.data.isRealName)
          sessionStorage.setItem('realcode', res.data.data.realcode)
        }
      })
    },
    editDetail() {
      if (this.type === 'add') {
        this.title = 'Add New'
      } else if (this.type === 'edit') {
        this.title = 'Modifying'
        this.isShowPhoto = false
        this.editTicketID = ''+this.$route.query.tktID
        api.getticketdetails({tktID: ''+this.$route.query.tktID}).then(res => {
          if (res.data.code === 200) {
            for (var item in this.tktObj) {
              this.tktObj[item] = res.data.data[item]
              if (item === 'tktBthCode' && !this.tktObj[item]) {
                this.tktObj[item] = JSON.parse(localStorage.getItem('userInfo')).bthCode
                // console.log(this.tktObj[item], item)
              }
            }
            this.idTypeChange()
          }
          
        })
      }
    },
    validatePassNO (rule, value, callback){
      if (rule.required) {
        if(value){
          if ((this.tktObj.tktIdType && this.tktObj.tktIdType ==='ID card') || (this.tktObj.tktCountry && this.tktObj.tktCountry ==='中国')) {
            if (!validateIDcard(value)) {
              callback(new Error(rule.message))
            } else {
              callback()
            }
          } else {
            callback()
          } 
        } else {
          callback(new Error(rule.message))
        }
      }else{
         callback()
      }
    },
    validateProvince (rule, value, callback) {
      if (rule.required) { // 如果省份必填
        if (this.tktObj.tktCountry === '中国' || this.tktObj.tktCountry === undefined) { // 已选择中国或没有国家选项
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    validateCity (rule, value, callback) {
      if (rule.required) {
        if (this.tktObj.tktProvince) {
          if (!value) {
            callback(new Error(rule.message))
          } else {
            callback()
          }
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    // 获取城市选项
    getCitys() {
      api.getallcitysbyprovince({
        exhId: this.exhId || sessionStorage.getItem('exhId'),
        zptProvince: this.tktObj.tktProvince
      }).then((res) => {
        this.citysList = res.data.data
      })
    },
    // 获取省份选项
    getallprovinces() {
      api.getallprovinces({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        this.provinceList = res.data.data
      })
    },
    //获取国家选项
    getCountrys() {
      api.getallcountrys({
        exhId: this.exhId || sessionStorage.getItem('exhId')
      }).then((res) => {    
        this.countryList = [{zptArea: "国内",zptCity: "中国"}, ...res.data.data]
      })
    },
    //国家切换
    changeCountry(){
      if(this.tktObj.tktCountry !='中国'){
        this.tktObj.tktProvince= ''
        this.tktObj.tktCity =''
        this.provinceList = []
        this.citysList =[]
        if (this.tktObj.hasOwnProperty('tktIdType')) {// 如果有身份证件类型属性
          // 处理证件类型选项
          this.cerType = ['护照', '港澳台通行证']
          // 把证件类型值置为空
          this.tktObj.tktIdType = ''
        }
      } else {
        // 获取省份
        this.getallprovinces()
        if (this.tktObj.hasOwnProperty('tktIdType')) {// 如果有身份证件类型属性
          // 处理证件类型选项
          this.cerType = ['身份证']
          // 把证件类型值置为空
          this.tktObj.tktIdType = ''
        }
      }
    },
    //切换省份
    changeProvince() {
      this.tktObj.tktCity =''
      this.getCitys()
    },
    rulesFn(item){
      var temp = ''
      var rulesData= {
        tktName: [
          { required: item.required, message: 'Enter '+item.fieldName, trigger: 'blur' },
          { pattern: reg.regName, message: item.fieldName+' Enter 2-20 Chinese characters or 2-50 English characters', trigger: 'blur' }
        ],
        tktEName: [
          { required: item.required, message: 'Enter '+item.fieldName, trigger: 'blur' },
          { pattern: reg.regName, message: item.fieldName+' Enter 2-20 Chinese characters or 2-50 English characters', trigger: 'blur' }
        ],
        tktComName: [
          { required: item.required, message: 'Enter '+item.fieldName, trigger: 'blur' },
          { pattern: reg.ComName, message: item.fieldName +'Enter 2-100 characters', trigger: 'blur' }
        ],
        tktRank: [
          { required: item.required, message: 'Enter '+item.fieldName, trigger: 'change' },
          { pattern: reg.Rank, message: item.fieldName+'格式错误！', trigger: 'blur' }
        ],
        tktCountry: [{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName}],
        tktIdType: [{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName}],
        tktProvince:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateProvince}],
        tktCity:[{ required: item.required, trigger: 'change', message: '请选择'+item.fieldName,validator: this.validateCity}],
        tktZipCode: [{ required: item.required, trigger: 'change', message: 'Enter correctly '+item.fieldName,  validator: validateChineseZipCode }],
        tktMobile: [{ required: item.required, trigger: 'blur', message: 'Enter correctly '+item.fieldName }],   // validator: validateMobile
        tktEmail: [{ required: item.required, trigger: 'blur', message: 'Enter correctly '+item.fieldName, validator: validateEmail }],
        photo: [{ required: item.required, trigger: 'change', message: 'upLoad '+item.fieldName}],
        tktFax: [{ required: item.required, trigger: 'change', message: "Enter correctly "+item.fieldName,validator: validateTelele}],
        tktPassportNo: [{ required: item.required, trigger: 'change', message: "Enter correctly "+item.fieldName, validator: this.validatePassNO}],
        tktTel: [{ required: item.required, trigger: 'change', message: "Enter correctly "+item.fieldName,validator: validateTelele}],
        tktAddress: [{ required: item.required, trigger: 'blur', message: item.fieldName+" Enter 6-100个字符", validator: validateAddress}],
        tktEAddress: [{ required: item.required, trigger: 'blur', message: item.fieldName+" Enter 6-100个字符", validator: validateAddress}],
        other:{required:item.required, message: item.fieldName+' 不能为空', trigger: 'blur'},
        select:{required:item.required, message: '请选择', trigger: 'change',validator:function(rule, value, callback){
          if( value || rule.required ){
              if (value == '') {
                callback(new Error('请选择'))
              } else {
                callback()
              }
          }else{
              callback()
          }
        }}
      }
      switch (item.fieldKey){
        case 'tktName':
        case 'tktEName':
        case 'tktComName':
        case 'tktRank':
        case 'tktCountry':
        case 'tktProvince':
        case 'tktCity':
        case 'tktEmail':
        case 'tktZipCode':
        case 'tktTel':
        case 'tktFax':
        case 'tktMobile':
        case 'tktPassportNo':
        case 'tktIdType':
        case 'tktAddress':
        case 'tktEAddress':
        case 'photo':
            temp = item.fieldKey
            break;
        case 'tktGender':
            temp = 'select'
            break;
        default: 
            temp = 'other'
            break
      }
      return rulesData[temp]
    },
    async getsaasfield() {
      await api.getsaasfield({type: 'ticket'}).then(res => {
        if (res.data.code  === 200){
          this.tktList.list =[]
          for(var i = 0;i<res.data.data.length;i++){
            if(res.data.data[i].enable == 1){
              this.tktList.list.push(res.data.data[i])
            }
          }
          for(var j=0;j<this.tktList.list.length;j++){
            if ( this.tktList.list[j].fieldKey === 'tktBthCode' ) {
              this.$set( this.tktObj,this.tktList.list[j].fieldKey, JSON.parse(localStorage.getItem('userInfo')).bthCode)
            } else if (this.tktList.list[j].fieldKey === 'tktComName') {
              this.$set( this.tktObj,this.tktList.list[j].fieldKey, JSON.parse(localStorage.getItem('userInfo')).atrName)
            } else if( this.tktList.list[j].fieldKey === 'tktIdType' ) {
              this.$set( this.tktObj,this.tktList.list[j].fieldKey, 'ID card')
            } else {
              this.$set( this.tktObj,this.tktList.list[j].fieldKey,'')
            }
          }
          this.idTypeChange()
          this.editDetail()
        }
      })
    },
    addOrEfit() {
      // this.tktObj.tktType = '参展证'
      if (this.type === 'add') {
        this.tktObj.FirstName = this.tktObj.tktName
        api.addticket(this.tktObj).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: 'success',
              message: 'Added successfully!',
              type: 'success'
            });
            this.dialogFormVisible = false
            this.$router.go(-1)
          }
        })
      } else {
        var param = {tktID: this.editTicketID}
        for (var item in this.tktObj) {
          if (item === 'tktID') {
            param[item] = ''+this.tktObj[item]+''
          } else {
            param[item] = this.tktObj[item]
          }
          
        }
        param.FirstName = param.tktName
        api.updateticket(param).then(res => {
          if (res.data.code === 200) {
            this.$notify({
              title: 'success',
              message: 'Modified successfully!',
              type: 'success',
            });
            this.dialogFormVisible = false
            this.$router.go(-1)
          }
        })
      }
    },
    idTypeChange(){
      // console.log(this.tktObj.tktIdType ,'qqqqqqqqqqqqq')
      this.isShowPhoto = this.tktObj.tktIdType !== 'ID card'
    },
    submitForm(formName) {

      for(var i in this.tktObj ){
        // console.log(i,'ddddddddddddddddddddd')
        // console.log(this.tktObj[i],'ddddddddddddddddddddd')
          if(this.tktObj[i] && i !='tktID' ){
            this.tktObj[i] = this.tktObj[i].trim()
          }
        // 
      }
      if (this.tktObj.tktPrintLanguage === 'en'){
        if (this.tktObj.tktEName === ''){
          this.$notify({
            title: 'Tip',
            message: 'Please fill in your English name！',
            type: 'error'
          });
          return;
        }
        if (this.tktObj.tktComEName === ''){
          this.$notify({
            title: 'Tip',
            message: 'Please fill in the English company！',
            type: 'error'
          });
          return;
        }
        if (this.tktObj.tktERank === ''){
          this.$notify({
            title: 'Tip',
            message: 'Please fill in the English job title！',
            type: 'error'
          });
          return;
        }
      }
      // console.log(this.tktObj,'111111111111111')
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (sessionStorage.getItem('isRealName') && sessionStorage.getItem('isRealName') === 'true') {
              if ((this.tktObj.tktCountry && this.tktObj.tktCountry === '中国') || (this.tktObj.tktIdType && this.tktObj.tktIdType === 'ID card')) {
              realNameVerification(this, this.tktObj.tktName, this.tktObj.tktPassportNo).then(backRes=>{
                if (backRes === 'true') {
                  this.addOrEfit()
                }
              })
              return;
            } else {
              this.addOrEfit()
            }
          } else {
            this.addOrEfit()
          }
        } else {
          // this.$notify({
          //   title: '请检查表单填写项是否符合规范！',
          //   type: 'error',
          // })
          return false;
        }
      });
    },
    async uploadFile(event) {
      let file = event.target.files[0]; //获取input的图片file值
      let param = new FormData(); // 创建form对象
      param.append("imgFile", file); //对应后台接收图片名
      await uploadPicture(param).then(res => {//uploadPicture为我的api接口
        if (res.code == 1) {
          let url = res.url[0].url;
          this.tempImg = "online" + url;
        }
      });
      this.$notify({
        duration: 3000,
        title: "success",
        message: "Upload successful！",
        type: "success"
      });
    },
    cancelAdd() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.addCard{
  .dialog-footer{
    text-align: center;
  }
  .demo-ruleForm{
    width:60%;
    margin: 20px auto;
  }
  @media screen and (max-width:540px){
    .demo-ruleForm{
      width:100%;
    }
    .dash-upload{
      width:200px;
    }
    .el-input__inner{
      border:0;
      text-align: right;
    }
    .el-form-item{
      border-bottom: 1px solid #DCDFE6;
    }
    .el-form-item__error{
      text-align: right;
      width:100%;
    }
  }
}
</style>

